// extracted by mini-css-extract-plugin
export default {"navBox":"Nav_navBox__K2lnc","mobile":"Nav_mobile__Wodu6","desktop":"Nav_desktop__GYqbW","background":"Nav_background__9nRi3"};